import {Diamond} from "@/api/Diamond";
import {computed, ComputedRef} from "vue";
import {useI18n} from "vue-i18n";
import formatCurrency from "@/utils/formatCurrency";

export default function useDiamondProperties(
    diamond: ComputedRef<Diamond | null>
) {
    const {locale} = useI18n();

    const productId = computed(() => diamond.value?.shopifyProductId);
    const carat = computed(() => diamond.value?.carat);
    const shape = computed(() => diamond.value?.shape);
    const color = computed(() => diamond.value?.color);
    const clarity = computed(() => diamond.value?.clarity);
    const cut = computed(() => diamond.value?.cut);
    const price = computed(() => diamond.value?.price);
    const highlighted = computed(() => diamond.value?.highlighted);
    const videoLink = computed(() => diamond.value?.videoLink);
    const certificateUrl = computed(() => diamond.value?.certificateLink);

    const priceHumanReadable = computed(() => {
        // ToDo: Workaround for exchange rate
        //@ts-expect-error Global not defined
        const currencyRate = parseFloat(window.Shopify?.currency?.rate ?? "1");

        // ToDo: Workaround for US markets rate
        //@ts-expect-error Global not defined
        const multiplier = window.Shopify?.country === "US" ? 1.1 : 1;

        return formatCurrency(
            ((price.value ?? 0) * currencyRate * multiplier) / 100
        );
    });

    return {
        productId,
        carat,
        shape,
        color,
        clarity,
        cut,
        price,
        highlighted,
        priceHumanReadable,
        videoLink,
        certificateUrl,
    };
}
